import React, { useEffect, useRef } from 'react';
const {tableau} = window

export default function TableauInfoYearly() {
  const ref = useRef(null)
  const url =  "https://public.tableau.com/views/E-infovsmydatayearly/Diffeinfovsmydata-current2?:language=en-US&publish=yes&:display_count=n&:showShareOptions=false&:origin=viz_share_link&:size=1380,1&:embed=y&:showVizHome=n&:bootstrapWhenNotified=y&:tabs=n&:apiID=host8#navType=1&navSrc=Parse"

  const options = {
    hideTabs: true,
    hideToolbar: true,
  }

  function initViz(){
    new tableau.Viz(ref.current, url, options)
  }

  useEffect(() => {
    initViz()
  }, [])

  return (
    <div ref={ref} style={{width:'100%', height:'100vh'}}></div>
  );
}